module.exports = __webpack_public_path__ + "img/empty.3c78f041.png";